// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chevron-right-s"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M10.7344 8.46448L14.2699 12L10.7344 15.5355","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chevron-right-s')
export default class ChevronRightSIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chevron-right-s',
    }
  }
}
